import {getPrice, iterateSumUpDayProducts} from "./BarGraphUtils";
import {byOptionsMode, byProductMode, byStaffMode} from "./constants";
import localStrings from "../localStrings";


function getOrderTotal(order) {
    let items = order.items || []
    let total = 0;
    items.forEach(item => {
        total += getPrice(item.price) * item.quantity;
    })
    return total;
}

export function getDataWeekOrMonth(mergedSumUpDayProductsFiltered, mergedSumUpDay, products, staffs,
                                   displayMode, product, mapOptionOptionList) {
    // if (!sumUpDay || !sumUpDay.detailbyStaff) {
    //     return [];
    // }

    if (displayMode === byOptionsMode) {
        return getOptionsDataByWeekOrMonth(mergedSumUpDayProductsFiltered, mapOptionOptionList);
    }

    if (displayMode === byProductMode && products) {
        return getProductDataByWeekOrMonth(mergedSumUpDay, products);
    }

    if (displayMode === byStaffMode && staffs) {
        return getStaffDataByWeekOrMonth(mergedSumUpDay, staffs);
    }

    return [];

}

export function getDataSingleDay(orders, displayMode, additionalFilters, transformer) {


    if (!orders || orders.length === 0) {
        return [];
    }

    if (additionalFilters && additionalFilters.length > 0) {
        additionalFilters.forEach(filter => {
            orders = orders.filter(filter);
        });
    }

    if (transformer) {
        let newOrders = [];
        orders = orders.map(order => {
            const orderTransformed = transformer(order);
            if (orderTransformed) {
                newOrders.push(orderTransformed);
            }
        })
        orders = newOrders;
    }

    if (!orders || orders.length === 0) {
        return [];
    }

    if (displayMode === byStaffMode) {
        return getStaffData(orders);
    }

    if (displayMode === byProductMode) {
        return getProductData(orders);
    }

    if (displayMode === byOptionsMode) {
        return getOptionsData(orders);
    }

    return null;
}

export function getStaffData(orders) {
    let staffTurnoverData = {};
    (orders || []).forEach(order => {
        if (order.staff) {
            if (!staffTurnoverData[order.staff.staff_name]) {
                staffTurnoverData[order.staff.staff_name] = {
                    asset: order.staff.staff_name,
                    amount: getOrderTotal(order.items || [])
                }
            } else {
                staffTurnoverData[order.staff.staff_name].amount += getOrderTotal(order);
            }
        }

    })
    return Object.values(staffTurnoverData);
}

export function getStaffDataByWeekOrMonth(mergedSumUpDay, staffs) {
    let staffTurnoverData = {};
    const keysStaff = Object.keys(mergedSumUpDay.detailbyStaff);

    keysStaff.forEach(staffRef => {
        let staffItem = staffs.find(staff => staff.id === staffRef);
        if (!staffItem) {
            staffItem = staffs.find(staff => staff.name === staffRef);
        }

        const staff = mergedSumUpDay.detailbyStaff[staffRef];
        staffTurnoverData[staffRef] = {
            asset: staffItem?.name || localStrings.unknown,
            amount: staff.totalTurnover
        }
    })

    // (orders || []).forEach(order => {
    //     if (order.staff) {
    //         if (!staffTurnoverData[order.staff.staff_name]) {
    //             staffTurnoverData[order.staff.staff_name] = {
    //                 asset: order.staff.staff_name,
    //                 amount: getOrderTotal(order.items || [])
    //             }
    //         } else {
    //             staffTurnoverData[order.staff.staff_name].amount += getOrderTotal(order);
    //         }
    //     }
    //
    // })
    return Object.values(staffTurnoverData);
}



export function getProductData(orders) {
    let productData = {};
    (orders || []).forEach(order => {
        order.items.forEach(item => {
            if (!productData[item.product_name]) {
                productData[item.product_name] = {
                    asset: item.product_name,
                    amount: getPrice(item.price) * item.quantity
                }
            } else {
                productData[item.product_name].amount += getPrice(item.price) * item.quantity;
            }
        })

    })
    return Object.values(productData);
}

export function getProductDataByWeekOrMonth(mergedSumUpDay, products) {
    let productData = {};


    iterateSumUpDayProducts(mergedSumUpDay, (productRef, productIter) => {
        var product = products.find(product => product.ref === productRef);
        if (!product) {
            product = products.find(product => product.name === productRef);
        }
        if(!product) {
            return;
        }
        if (!productData[productRef]) {
            productData[productRef] = {
                asset: product.name,
                amount: productIter.totalPrice
            }
        } else {
            productData[productRef].amount += productIter.totalPrice;
        }
    })

    // (orders || []).forEach(order => {
    //     order.items.forEach(item => {
    //         if (!productData[item.product_name]) {
    //             productData[item.product_name] = {
    //                 asset: item.product_name,
    //                 amount: getPrice(item.price) * item.quantity
    //             }
    //         } else {
    //             productData[item.product_name].amount += getPrice(item.price) * item.quantity;
    //         }
    //     })
    //
    // })
    return Object.values(productData);
}

export function getOptionsDataByWeekOrMonth(products, mapOptionOptionList) {
    let optionsData = {};
    products.forEach(product => {
        if (!product.options || product.options.length == 0) {
            return;
        }
        var optionKeys = Object.keys(product.options);
        optionKeys.forEach(optionKey => {
            const option = product.options[optionKey];
            var optionName = mapOptionOptionList[optionKey] ? mapOptionOptionList[optionKey].name : optionKey;

            if (!optionsData[optionName]) {
                optionsData[optionName] = {
                    asset: optionName,
                    amount: parseInt(option.quantity)
                }
            } else {
                optionsData[optionName].amount += parseInt(option.quantity);
            }
        })

        // product.options.forEach(option => {
        //     if (!optionsData[option.option_list_name]) {
        //         optionsData[option.option_list_name] = {
        //             asset: option.option_list_name,
        //             amount: parseInt(option.quantity) * product.quantity
        //         }
        //     } else {
        //         optionsData[option.option_list_name].amount += parseInt(option.quantity) * parseInt(product.quantity);
        //     }
        // })
    });
    return Object.values(optionsData);
}

export function getOptionsData(orders) {
    let optionsData = {};
    (orders || []).forEach(order => {
        order.items.forEach(item => {
            if (!item.options || item.options.length == 0) {
                return;
            }

            item.options.forEach(option => {
                if (!optionsData[option.option_list_name]) {
                    optionsData[option.option_list_name] = {
                        asset: option.option_list_name,
                        amount: parseInt(option.quantity) * item.quantity
                    }
                } else {
                    optionsData[option.option_list_name].amount += parseInt(option.quantity) * parseInt(item.quantity);
                }
            })
        })
    })
    return Object.values(optionsData);
}

export function getOptionsDataByProductItems(productItems, optionsLists) {
    let optionsData = {};
    (productItems || []).forEach(productItem => {
        productItem.items.forEach(item => {
            if (!item.options || item.options.length == 0) {
                return;
            }
            const keysOption = Object.keys(item.options);
            keysOption.forEach(optionsRef => {
                const optionListOfItem =
                    optionsLists.find(optionList => optionList.options.map(op => op.ref).includes());

                const optionDef = optionListOfItem.options.find(option => option.ref === optionsRef);

                const optionDetail = item.options[optionsRef];
                if (!optionsData[optionListOfItem.name]) {
                    optionsData[optionListOfItem.name] = {
                        asset: optionDef.name,
                        amount: parseInt(optionDetail.quantity) * item.quantity
                    }
                } else {
                    optionsData[optionListOfItem.name].amount += parseInt(optionDetail.quantity) * item.quantity
                }
            })


        })
    })
    return Object.values(optionsData);
}